export const isNumber = text => /^-{0,1}\d+(\.\d+){0,1}$/.test(text)

export default isNumber
